import React from "react";
import { NavLink } from "react-router-dom";
//import { FacebookProvider, Like } from 'react-facebook';

import logo from "../img/logo.jpg";

export const Header = props => {
  return (
    <header className="header">
      <NavLink to="/">
        <img src={logo} alt="45 Zjazd Fizyków Polskich - Kraków 2019" />
      </NavLink>

      <nav className="header-menu">
        <NavLink to="/o-zjezdzie">O zjeździe</NavLink>

        <div className="dropdown" ><span>Komitety</span>
        <ul className="dropdown-content">
          <li>
            <NavLink to="/komitety/patronat-honorowy">Patronat Honorowy</NavLink>
            <NavLink to="/komitety/honorowy">Komitet Honorowy</NavLink>
            <NavLink to="/komitety/programowy">Komitet Programowy</NavLink>
            <NavLink to="/komitety/organizacyjny">Komitet Organizacyjny</NavLink>
          </li>
        </ul>
        </div>

        <div className="dropdown"><span>Program</span>
        <ul className="dropdown-content">
          <li>
            <NavLink to="/program/ramowy">Program ramowy</NavLink>
            <NavLink to="/program/sesje">Sesje naukowe</NavLink>
            <NavLink to="/program/harmonogram-online">Harmonogram On-line</NavLink>
            <NavLink to="/program/sesja-plakatowa">Sesja plakatowa</NavLink>
            <NavLink to="/program/konferencja-dydaktyczna">Konferencja Dydaktyczna</NavLink>
            <NavLink to="/program/dzien-agh">Dzień AGH</NavLink>
            <NavLink to="/program/ksiazka-streszczen">Książka streszczeń</NavLink>
            <NavLink to="/program/plakat-konferencyjny">Plakat konferencyjny</NavLink>
          </li>
        </ul>
        </div>

        <div className="dropdown"><span>Atrakcje</span>
          <ul className="dropdown-content">
            <li>
              <NavLink to="/atrakcje/dzien-otwarty">Dzień otwarty</NavLink>
            </li>
          </ul>
        </div>

        <NavLink to="/sesja-innowacje">Sesja Innowacje</NavLink>

        <div className="dropdown" ><span>Sponsorzy</span>
        <ul className="dropdown-content">
          <li>
            <NavLink to="/sponsorzy/lista-sponsorow">Patroni i partnerzy</NavLink>
            <NavLink to="/sponsorzy/oferta-wspolpracy">Oferta współpracy</NavLink>
          </li>
        </ul>
      </div>

      <NavLink to="/miejsce">Miejsce</NavLink>

        <div className="dropdown" ><span>Rejestracja</span>
          <ul className="dropdown-content">
            <li>
              <NavLink to="/rejestracja/oplaty-konferencyjne">Terminy i opłaty</NavLink>
              <NavLink to="/rejestracja/formularz-rejestracyjny">Rejestracja uczestników</NavLink>
              <NavLink to="/rejestracja/zakwaterowanie">Zakwaterowanie</NavLink>
              <NavLink to="/rejestracja/sesja-innowacje">Sesja innowacje (rejestracja)</NavLink>
            </li>
          </ul>
        </div>

        <div className="dropdown" ><span>Po Zjeździe</span>
          <ul className="dropdown-content">
            <li>
              <NavLink to="/po-zjezdzie/proceedings">Materiały pokonferencyjne</NavLink>
              <NavLink to="/po-zjezdzie/galeria">Galeria zdjęć</NavLink>
              <NavLink to="/po-zjezdzie/nagrania-wykladow">Nagrania wykładów</NavLink>
              <NavLink to="/po-zjezdzie/nagranie-widowisko-multimedialne">Nagranie widowiska z muzyką J. Skrzeka</NavLink>
              <NavLink to="/po-zjezdzie/nagranie-koncert-w-operze">Nagranie koncertu w Operze Krakowskiej</NavLink>


            </li>
          </ul>
        </div>

        <NavLink to="/kontakt">Kontakt</NavLink>
      </nav>
    </header>
  );
};

Header.propTypes = {};
